import React, { useEffect, useState } from 'react';
import { Row, Col, Image, Carousel } from 'react-bootstrap';
import ZoomModal from './ZoomModal';
import {
  capitalizeFirstLetter,
  getSpecialCountTime,
  getUpcomingDate,
  getUpcomingTime,
  getUserProfileUrl,
} from '../../../utils/camp.utils';
import ZoomButton from './ZoomButton';
import Avatar from '../../../assets/images/my_room_active.svg';
import dateEvents from '../../../assets/images/dateevents.svg';
import Time from '../../../assets/images/time.svg';
import DateImg from '../../../assets/images/date1.svg';
import './css/camp.schedule.scss';
import Countdown, { zeroPad, formatTimeDelta } from 'react-countdown';
import { specialCampViewModel } from '../special_camp/special.camp.viewmodel';
import ZoomButtonSpecialCamp from './ZoomButtonSpecialCamp';
import {
  ADD_TWENTY_MINUTE_PROMISE_ROUTE,
  SPECIAL_CAMP_LIST,
  TREEHOUSE_ROUTE,
} from '../../../constants/routes.constants';
import IIcon from '../../../assets/icon/PRINT.svg';
import KidPromiseImg from '../../../assets/images/tour/kid_promise.svg';
import CreativeCampImg from '../../../assets/images/tour/kid_creative_camp.svg';
import DreamCampImg from '../../../assets/images/tour/kid_dream_camp.svg';

const TwentyMinPromise = ({ data, dependent }) => {
  const getSchedule = () => {
    const convertedTime = getUpcomingTime(data.day, data.time, data.timezone);
    return `${convertedTime}`;
  };

  const getDate = () => {
    const res = getUpcomingDate(data.day, data.time, data.timezone);
    return format(res, 'dd MMMM yyyy');
  };

  const getTime = () => {
    // Define the time and timezone
    const time = data.time;
    const timezone = data.timezone;
    return `${time} (${timezone})`;
  };

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    return (
      <h5 className="f-600">
        <div className="countdown">
          <div className="counts-days">
            <span id="days">{days}</span>
            <br />
            <span>Days</span>
          </div>
          <div className="counts-days">
            <span id="hrs">{zeroPad(hours)}</span>
            <br />
            <span>hrs</span>
          </div>
          <div className="counts-days">
            <span id="mins">{zeroPad(minutes)}</span>
            <br />
            <span>mins</span>
          </div>
          <div className="counts-days">
            <span id="secs">{zeroPad(seconds)}</span>
            <br />
            <span>secs</span>
          </div>
        </div>
      </h5>
    );
  };

  return (
    <>
      <div className="camp-schedule-title p-3">{'20 min promise!'}</div>
      <div className="inner-camp-box-my-room width-box">
        <div className="width-box camp-captain-profile-box">
          <h6 class="craft-meet">
            <Image
              src={getUserProfileUrl(dependent)}
              alt=""
              className="date"
              width="40"
            />
            Weekly talk with: <span>{dependent?.username}</span>
          </h6>

          <h6 class="craft-meet">
            <Image src={DateImg} alt="" className="date" width="40" />
            Date: {capitalizeFirstLetter(data?.day)} {getDate()}
          </h6>

          <h6 class="craft-meet">
            <Image src={Time} alt="" className="date" width="40" />
            Time: {getTime()}
          </h6>

          <Countdown
            date={Date.now() + Number(getSchedule())}
            renderer={countdownRenderer}
            // overtime={true}
            // onComplete={handleComplete}
          />
        </div>
      </div>
    </>
  );
};

const SpecialCampComp = ({ camp }) => {
  const getSpecialCampSchedule = () => {
    const convertedTime = getSpecialCountTime(
      camp?.end_date_time,
      camp?.timezone
    );
    return convertedTime;
  };

  const getSpecialCampDate = () => {
    const date = new Date(camp?.end_date_time);

    // Format the date using toLocaleDateString
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    };
    const formattedDate = date.toLocaleDateString('en-GB', options);

    return formattedDate;
  };

  const getSpecialCampTime = () => {
    const date = new Date(camp?.end_date_time);

    // Convert the date to the target timezone offset
    const options = { hour12: false, hour: '2-digit', minute: '2-digit' };
    const time = date.toLocaleTimeString('en-GB', options).replace(':', 'h');

    return `${time} (${camp?.timezone})`;
  };

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // setIsCompleted(true)
      return (
        <div className="join-button px-3">
          <ZoomButtonSpecialCamp title="Join Camp" link={camp?.zoom_link} />
        </div>
      );
    } else {
      return (
        <h5 className="f-600">
          <div className="countdown">
            <div className="counts-days">
              <span id="days">{days}</span>
              <br />
              <span>Days</span>
            </div>
            <div className="counts-days">
              <span id="hrs">{zeroPad(hours)}</span>
              <br />
              <span>hrs</span>
            </div>
            <div className="counts-days">
              <span id="mins">{zeroPad(minutes)}</span>
              <br />
              <span>mins</span>
            </div>
            <div className="counts-days">
              <span id="secs">{zeroPad(seconds)}</span>
              <br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  return (
    <>
      <div className="camp-schedule-title p-3">{camp?.name}</div>
      <div className="inner-camp-box-my-room width-box">
        <div className="width-box camp-captain-profile-box">
          <h6 class="craft-meet">
            <Image
              src={
                camp?.created_by?.picture_url
                  ? camp?.created_by?.picture_url
                  : Avatar
              }
              alt=""
              className="date"
              width="40"
            />
            Meet the expert:{' '}
            <span>
              {' '}
              {camp?.created_by?.first_name} {camp?.created_by?.last_name}{' '}
            </span>
          </h6>

          <h6 class="craft-meet">
            <Image src={DateImg} alt="" className="date" width="40" />
            Date: {getSpecialCampDate()}
          </h6>

          <h6 class="craft-meet">
            <Image src={Time} alt="" className="date" width="40" />
            Time: {getSpecialCampTime()}
          </h6>

          <Countdown
            date={Date.now() + Number(getSpecialCampSchedule())}
            renderer={countdownRenderer}
            // overtime={true}
            // onComplete={handleComplete}
          />
        </div>
      </div>
    </>
  );
};

// import { treehouseViewModel } from './treehouse.view.modal';
import { treehouseViewModel } from '../treehouse/treehouse.view.modal';
import AddSchoolModal from '../dashboard/AddSchoolModal';
import { format } from 'date-fns';
import { campScheduleViewModel } from './camp.schedule.view.model';
import { useHistory } from 'react-router-dom';
import RoundButton from '../../common/RoundButton';
import { Skeleton, Typography } from '@mui/material';
import { useAuth } from '../../auth/Auth';
import GuardianNoDataTooltip from '../school/camp_tour/GuardianNoDataTooltip';
import MultiCampSlider from './MultiCampSlider';
const GuardianCamps = ({
  selectedDate = '',
  dependent,
  type,
  isPromiseLoading,
  twentyMinPromise,
}) => {
  const [showZoomModal, setShowZoomModal] = useState(false);
  const handleCloseZoomModal = () => setShowZoomModal(false);
  const [specialCamp, setSpecialCamp] = useState([]);
  const group = dependent ? dependent.profile?.group : '';
  const [showCampJoin, setShowCampJoin] = useState(false);
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const history = useHistory();
  const { guardian } = useAuth();
  const getSchedule = () => {
    const convertedTime = getUpcomingTime(
      group.day,
      group.time,
      group.timezone
    );
    return `${convertedTime}`;
    const [selectedSpecialCampt, setSetselectedSpecialCampt] = useState([]);
    // return getCampStatus(campStatus) || '';
  };

  const countdownRendererSchool = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }) => {
    if (completed) {
      // setShowCampJoin(true)
      return (
        <div className="join-button px-3">
          {group?.meet_link ? (
            <ZoomButtonSpecialCamp title="Join Camp" link={group?.meet_link} />
          ) : group?.zoom_link ? (
            <ZoomButtonSpecialCamp title="Join Camp" link={group?.zoom_link} />
          ) : (
            <ZoomButton title="Join Camp" creator={dependent} />
          )}
        </div>
      );
    } else {
      // setShowCampJoin(false)
      return (
        <h5 className="f-600">
          {/* <span>
            {days} Days:{zeroPad(hours)} Hrs:{zeroPad(minutes)} Mins:{zeroPad(seconds)} Secs
          </span> */}
          <div className="countdown">
            <div className="counts-days">
              <span id="days">{days}</span>
              <br />
              <span>Days</span>
            </div>
            <div className="counts-days">
              <span id="hrs">{zeroPad(hours)}</span>
              <br />
              <span>hrs</span>
            </div>
            <div className="counts-days">
              <span id="mins">{zeroPad(minutes)}</span>
              <br />
              <span>mins</span>
            </div>
            <div className="counts-days">
              <span id="secs">{zeroPad(seconds)}</span>
              <br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  // const getSpecialCamps = () => {
  //   if (dependent?.profile?.is_activated) {
  //     if (dependent?.special_camp?.special_camp_id) {
  //       specialCampViewModel
  //         .getDependentSpecialCamp(dependent?.special_camp?.special_camp_id)
  //         .then((res) => {
  //           if (
  //             res.id === dependent?.special_camp?.special_camp_id &&
  //             dependent?.special_camp?.attend === 'YES'
  //           ) {
  //             setSpecialCamp([res]);
  //           } else {
  //             setSpecialCamp([]);
  //           }
  //         })
  //         .catch((err) => {
  //           setSpecialCamp([]);
  //         });
  //     } else {
  //       setSpecialCamp([]);
  //     }
  //   } else {
  //     setSpecialCamp([]);
  //   }
  // };
  const getSpecialCamps = () => {
    specialCampViewModel
      .getDependentMultiSpecialCamps(dependent.id)
      .then((res) => {
        setSpecialCamp(res);
      })
      .catch((err) => {
        console.log(err, 'fetching error multiple special camp');
        setSpecialCamp([]);
      });
  };
  useEffect(() => {
    setIndex(0);
    getSpecialCamps();
  }, [dependent]);

  useEffect(() => {
    if (selectedDate) {
      // Find the special camp that matches the selected date
      const selectedCampIndex = specialCamp.findIndex((camp) => {
        const endDate = new Date(camp.end_date_time); // Convert end_date_time to Date object
        return endDate.getDate() === parseInt(selectedDate, 10); // Compare day with selected date
      });

      if (selectedCampIndex !== -1) {
        setActiveIndex(selectedCampIndex); // Update active index if a match is found
      }
    }
  }, [selectedDate, specialCamp]);
  const getDate = () => {
    const res = getUpcomingDate(group.day, group.time, group.timezone);
    return format(res, 'dd MMMM yyyy');
  };

  const getTime = () => {
    // Define the time and timezone
    const time = group.time;
    const timezone = group.timezone;
    return `${time} (${timezone})`;
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleAddMinPromise = () => {
    history.push({
      pathname: ADD_TWENTY_MINUTE_PROMISE_ROUTE,
      state: {
        dependent_id: dependent?.id,
        from: 'dashboard',
      },
    });
  };

  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);
  const [stepData, setStepData] = useState([]);
  const twentyMinPromiseStep = [
    {
      element: '#guardian-twentyMin-promise',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidPromiseImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Commit to the 20-Minute Promise</h3>
          <p>Every week, take 20 minutes to sit with your child and discuss their thoughts, feelings, and creations.</p>
          <p>This promise helps nurture a deeper connection and fosters creativity through meaningful conversations.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const twentyMinPromiseStepSchool = [
    {
      element: '#guardian-twentyMin-promise',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidPromiseImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Commit to the 20-Minute Promise</h3>
          <p>Every week, Guardians take 20 minutes to sit with their child and discuss their thoughts, feelings, and creations.</p>
          <p>This promise helps nurture a deeper connection and fosters creativity through meaningful conversations.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const connectCampStep = [
    {
      element: '#guardian-connect-camp',
      intro: `
        <div class="custom-tour-step">
          <img src="${CreativeCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Stay Connected with Creative Camps</h3>
          <p>Creative Camps offer your child the chance to engage in fun, imaginative activities alongside other kids.</p>
          <p>Keep track of upcoming camps and make sure your child is ready to create and collaborate!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const dreamCampStep = [
    {
      element: '#guardian-dream-camp',
      intro: `
        <div class="custom-tour-step">
          <img src="${DreamCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Join a Dream Camp!</h3>
          <p>Dream Camps are special experiences designed to help your child explore their deepest passions and unlock their full creative potential.</p>
          <p>Stay updated on upcoming Dream Camps and encourage your child to dive in!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const dreamCampStepSchool = [
    {
      element: '#guardian-dream-camp',
      intro: `
        <div class="custom-tour-step">
          <img src="${DreamCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Dream Camp!</h3>
          <p>Dream Camps are special experiences designed to help kids explore their deepest passions and unlock their full creative potential.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];

  const handleNoTwentyMinPromise = () => {
    setStepData(guardian ? twentyMinPromiseStep : twentyMinPromiseStepSchool);
    setShowNoDataTooltip(true);
  };

  const handleNoCamp = () => {
    setStepData(connectCampStep);
    setShowNoDataTooltip(true);
  };

  const handleNoDreamCamp = () => {
    setStepData(guardian ? dreamCampStep : dreamCampStepSchool);
    setShowNoDataTooltip(true);
  };
  return (
    <div
      className="camp-schedule-container creator-camp-box justify-content-center text-center"
      style={{ boxShadow: 'unset' }}
    >
      <AddSchoolModal show={show} setShow={setShow} dependent={dependent} />
      <GuardianNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={stepData}
      />

      {type === 'Creative' ? (
        group?.id ? (
          <>
            <div className="camp-schedule-title p-3">
              {dependent.school_details?.school_name
                ? dependent.school_details?.school_name
                : 'Upcoming Camp'}
            </div>
            <div className="inner-camp-box-my-room width-box">
              <div className="width-box camp-captain-profile-box countdown-div-btn">
                <h6 class="craft-meet tribe-image">
                  <Image
                    src={
                      dependent?.school_details?.picture
                        ? dependent?.school_details?.picture
                        : Avatar
                    }
                    alt=""
                    className="date"
                    width="40"
                  />
                  Tribe: <span> {dependent?.profile?.group?.name} </span>
                </h6>

                <h6 class="craft-meet camp-image">
                  <Image
                    src={
                      dependent?.profile?.group?.group_captain?.picture_url
                        ? dependent?.profile?.group?.group_captain?.picture_url
                        : Avatar
                    }
                    alt=""
                    className="date"
                    width="40"
                  />
                  Your Camp Captain:{' '}
                  <span>
                    {' '}
                    {dependent?.profile?.group?.group_captain?.first_name}{' '}
                    {dependent?.profile?.group?.group_captain?.last_name}
                  </span>
                </h6>

                <h6 class="craft-meet">
                  <Image src={dateEvents} alt="" className="date" width="40" />
                  Date: {capitalizeFirstLetter(group?.day)} {getDate()}
                </h6>

                <h6 class="craft-meet">
                  <Image src={Time} alt="" className="date" width="40" />
                  Time: {getTime()}
                </h6>

                <Countdown
                  // key={key}
                  date={Date.now() + Number(getSchedule())}
                  renderer={countdownRendererSchool}
                  // overtime={true}
                  // onComplete={handleComplete}
                />
              </div>
              {showCampJoin
                ? !group.meet_link &&
                  group.zoom_link && (
                    <>
                      <Row
                        className={`p-3 justify-content-center camp-schedule-zoom-details`}
                      >
                        <Col className="col-auto">
                          <div className="camp-schedule-details">
                            Check Meeting Id & Password &gt;
                          </div>
                        </Col>
                      </Row>
                      <ZoomModal
                        showModal={showZoomModal}
                        handleClose={handleCloseZoomModal}
                      />
                    </>
                  )
                : ''}
            </div>
          </>
        ) : (
          <div
            className="insights-text no-data-found"
            style={{ paddingTop: '75px' }}
            id="guardian-connect-camp"
          >
            <div className="text-wrapper">
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={handleNoCamp}
              />
              <Typography
                variant="body1"
                sx={{ color: '#321b6d', padding: '25px', paddingTop: 0 }}
              >
                You haven't connected a Camp yet. Why not take the opportunity
                to add one now.
              </Typography>
              <RoundButton
                type="button"
                label="Connect a Camp"
                className="transparent-button d-sm-block choose-challenge-btn"
                onClick={() => setShow(true)}
              />
            </div>
          </div>
        )
      ) : (
        ''
      )}
      {type === 'Special' && (
        <div className="camp-schedule-container creator-camp-box justify-content-center text-center">
          {dependent?.profile?.is_activated && specialCamp.length > 0 ? (
            <Carousel
              activeIndex={activeIndex}
              onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
              className="home-feed-caousel ofday"
              style={{ borderRadius: 'none !important' }}
            >
              {specialCamp.map((item, key) => (
                <Carousel.Item key={key}>
                  <SpecialCampComp camp={item} key={key} />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <div
              className="insights-text no-data-found"
              style={{ paddingTop: '75px' }}
              id="guardian-dream-camp"
            >
              <div className="text-wrapper">
                <Image
                  src={IIcon}
                  alt="no-data"
                  className="add-pointer"
                  onClick={handleNoDreamCamp}
                />
                <Typography
                  variant="body1"
                  style={{
                    color: '#321b6d',
                    padding: '25px',
                    paddingTop: 0,
                  }}
                >
                  {guardian
                    ? `Enroll ${dependent?.username} to Dream Camp! Where the kid can explore their passions.`
                    : `${dependent?.username} has not joined any Dream Camp.`}
                </Typography>
                {guardian && (
                  <RoundButton
                    type="button"
                    label="Get Dream Camp"
                    className="transparent-button d-sm-block choose-challenge-btn parent-login-btn"
                    onClick={() => {
                      history.push({
                        pathname: SPECIAL_CAMP_LIST,
                        state: {
                          dependent,
                        },
                      });
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {type === 'Promise' ? (
        isPromiseLoading ? (
          <Skeleton variant="rectangular" width="100%" height="300px" />
        ) : twentyMinPromise.length > 0 ? (
          <TwentyMinPromise data={twentyMinPromise[0]} dependent={dependent} />
        ) : (
          <div
            className="insights-text no-data-found"
            style={{ paddingTop: '75px' }}
            id="guardian-twentyMin-promise"
          >
            <div className="text-wrapper">
              <Image
                src={IIcon}
                alt="no-data"
                className="add-pointer"
                onClick={handleNoTwentyMinPromise}
              />
              <Typography
                variant="body1"
                style={{ color: '#321b6d', padding: '25px', paddingTop: 0 }}
              >
                {!guardian
                  ? `${dependent?.username}'s Guardian has not made a 20 Minute Promise at this time.`
                  : `Remember to add your 20-Minute Promise. It's a fantastic way to
                strengthen your bond and stay meaningfully connected with your
                child every week!`}
              </Typography>
              {guardian && (
                <RoundButton
                  type="button"
                  label="Add 20 Min Promise"
                  className="transparent-button d-sm-block choose-challenge-btn"
                  onClick={handleAddMinPromise}
                />
              )}
            </div>
          </div>
        )
      ) : (
        ''
      )}
    </div>
  );
};

export default GuardianCamps;
